export enum ENotificationActionType {
  HIDE_BLUE_DOT = 'NOTIFICATION/HIDE_BLUE_DOT',
  SET_NOTIFICATION = 'NOTIFICATION/SET',
}
